export default "__VITE_ASSET__vRRI3gUU__"